import React from 'react'
import { Link } from 'react-router-dom'
import './providerCard.css'

const ProviderCard = ({
    project_id,
    provider_name,
    provider_mobile,
    provider_avatar,
    rating_all_together,
    is_pro_user,
    provider_id,
    provider_project_id,
    title,
    years_of_experience,
    bid_amount,
    insured,
}) => {
    const redirectData = {
        pathname: `/provider-review/${project_id}`,
    };
    
    return (
        <div className="provider-summary-card">
            <div className="provider-summary-card__header">
                <div className="provider-summary-card__profile">
                    <img 
                        src={provider_avatar || "/assets/images/New-files/default-card-img-a.png"} 
                        alt={provider_name} 
                        className="provider-summary-card__avatar" 
                    />
                    <div className="provider-summary-card__info">
                        <div className="provider-summary-card__name-wrapper">
                            <h3 className="provider-summary-card__name">{provider_name}</h3>
                            {is_pro_user && <span className="provider-summary-card__badge">Pro+</span>}
                        </div>
                        <div className="provider-summary-card__stats">
                            {rating_all_together && (
                                <span className="provider-summary-card__rating">
                                    <span>{rating_all_together.rating_all_together}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#FFD700">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                    </svg>
                                    <span>({rating_all_together.reviews_all_together})</span>
                                </span>
                            )}
                            <span className="provider-summary-card__experience">
                                {years_of_experience}+ years
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="provider-summary-card__actions">
                {bid_amount !== 0 && (
                    <Link 
                        to={redirectData} 
                        className="provider-summary-card__button provider-summary-card__button--outline"
                    >
                        Mark as completed
                    </Link>
                )}
                <a 
                    href={`tel:${provider_mobile}`} 
                    className="provider-summary-card__button provider-summary-card__button--primary"
                >
                    Call Provider
                </a>
            </div>
        </div>
    );
};

export default ProviderCard;